export const DEFAULT_ACTION = 'app/Team/TeamApp/DEFAULT_ACTION';

export const FETCH_TEAM_APP_PERMISSIONS =
  'app/Team/TeamApp/FETCH_TEAM_APP_PERMISSIONS';
export const FETCH_TEAM_APP_PERMISSIONS_SUCCESS =
  'app/Team/TeamApp/FETCH_TEAM_APP_PERMISSIONS_SUCCESS';
export const FETCH_TEAM_APP_PERMISSIONS_FAILURE =
  'app/Team/TeamApp/FETCH_TEAM_APP_PERMISSIONS_FAILURE';

export const RESET_STATE = 'app/Team/TeamApp/RESET_STATE';

export const APP_TYPES = {
  FLOW: 'flow',
  DATA: 'data',
};
